import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import CardView from "../../../components/common/CardView";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import PositionTitlePresenter from "../PositionTitles/PositionTitlePresenter";
import {
  DialogConfirmation,
  formatDate,
} from "../../../components/common/Converter";
import Hierarchy from "../../../components/common/Hierarchy";
import DateRangePicker from "../../../components/common/DateRangePicker";
import InputFactory from "../../../components/InputFactory";

class JobPostingsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PositionTitlePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      description: "",
      sendToAll: false,
      offices: [],
      count: 0,
      limit: 10,
      current: 1,
      positionTitle: [],
      // fields: {}
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const positionTitle = await findObjectUseCase().execute("position_titles");
    this.setState({ positionTitle });
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }
  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () => {
      this.refetchData();
      this.showSuccess("Deleted successfully!");
    });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getCollectionName() {
    return "job_postings";
  }

  addNotices() {
    this.navigateTo(`/form/${this.getCollectionName()}/`);
  }

  submitMe() {
    upsertUseCase().execute(this.getCollectionName(), this.state);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleObjectChange(hierarchy) {
    const object = {
      region: hierarchy.selectedregions,
      office: hierarchy.selectedoffices,
      division: hierarchy.selecteddivisions,
      section: hierarchy.selectedsections,
      unit: hierarchy.selectedunits,
      cluster: hierarchy.selectedplantilla,
    };

    const filteredObject = {
      positionTitle: Object.fromEntries(
        Object.entries(object).filter(([_, value]) => value) // Keep entries with truthy values
      ),
    };

    console.log("OBJECT: ", filteredObject);
    // return;

    this.filterSubmit(filteredObject);
    // Object.entries(filteredObject).forEach(([field, value]) => {
    // });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    if (!schema) return <Progress />;
    console.log("OIBSS: ", objects);
    // const user = this.getCurrentUser();

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Recruitment {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex gap-3 ps-2 pe-2">
                  <div className="row">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                  </div>

                  <div>
                    <DateRangePicker
                      fields={["createdAt", "updatedAt", ""]}
                      onFilter={(filterObj) => {
                        try {
                          const update = new Date(filterObj.updatedAt.$lte);
                          update.setDate(update.getDate() + 1);
                          const formattedDate = update
                            .toISOString()
                            .split("T")[0];
                          console.log("UDPATE: ", formattedDate);
                          const filterStartDate = {
                            createdAt: {
                              $lte: formattedDate,
                              $gte: filterObj.createdAt.$gte,
                            },
                          };
                          this.searchSubmit(filterStartDate);
                          this.setState({ filters: filterStartDate });
                        } catch (e) {
                          this.searchSubmit({});
                          this.setState({ filters: {} });
                        }
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.addNotices.bind(this)}>
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                editId={this.handleEditData.bind(this)}
                objectId={this.handleDeleteData.bind(this)}
                refetch={this.refetchData.bind(this)}
                progress={loading}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "positionTitle"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(JobPostingsPage);
